"use client";
// IosZoomLock — iOS Safari'de çimdikleyerek (pinch) yakınlaştırmayı kapatır.
//
// NEDEN META YETMİYOR: iOS 10'dan beri Safari, erişilebilirlik gerekçesiyle
// viewport meta'sındaki `user-scalable=no` ve `maximum-scale` değerlerini
// yok sayabiliyor. layout.tsx'teki viewport export'u niyeti bildirir ve
// `minimum-scale=1` ile uzaklaştırmayı (asıl sorun) kesin olarak kapatır;
// yakınlaştırmayı da kilitlemek için gesture olaylarını burada durduruyoruz.
//
// `gesturestart` WebKit'e özgü, standart olmayan bir olay — TypeScript'in DOM
// olay haritasında yok, bu yüzden dinleyici düz `Event` alıyor. Diğer
// tarayıcılarda olay hiç ateşlenmez, dolayısıyla kod ölü ama zararsızdır.
//
// touchmove'a DOKUNULMUYOR: `{ passive: false }` ile document'a touchmove
// bağlamak her scroll karesini bloklanabilir hâle getirir ve sayfadaki
// Swiper'ların dokunma performansını düşürür. Çift dokunma zoom'u ise JS değil,
// globals.css'teki `touch-action: manipulation` ile kapatılıyor.
import { useEffect } from "react";

const GESTURE_EVENTS = ["gesturestart", "gesturechange", "gestureend"] as const;

const IosZoomLock = () => {
  useEffect(() => {
    const blockGesture = (e: Event) => e.preventDefault();

    for (const type of GESTURE_EVENTS) {
      document.addEventListener(type, blockGesture, { passive: false });
    }

    return () => {
      for (const type of GESTURE_EVENTS) {
        document.removeEventListener(type, blockGesture);
      }
    };
  }, []);

  return null;
};

export default IosZoomLock;
